// Remove page width class to all instances of the social media feed section by plugin

const instaFeedContainers = document.querySelectorAll(".social-widget-wrapper");
const instaFeedSections = [];

instaFeedContainers.forEach((iContainer) => {
  const parentSection = iContainer.parentElement.parentElement.parentElement;
  if (!instaFeedSections.includes(parentSection)) {
    instaFeedSections.push(parentSection);
  }
});

instaFeedSections.forEach((element) => {
  element.firstChild.classList.remove("page-width");
});
